import React, { useState, useEffect } from "react";
import { get, post } from "../../../services/api";
import { toast } from "react-toastify";

function NewApplicantForm() {
  const token = localStorage.getItem("token");

  const [jobPostings, setJobPostings] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    jobPostingId: "",
    city: "",
    expectedSalary: "",
    resumePath: "",
    notes: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const organizationId = localStorage.getItem("organizationId");
  useEffect(() => {
    fetchJobPostings();
  }, []);

  const fetchJobPostings = async () => {
    try {
      const response = await get(
        `Onboarding/job-postings?organizationId=${organizationId}&CenterId=${savedCenterId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.success) {
        setJobPostings(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching job postings:", error);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // In production, upload file to server and get URL
      setFormData({ ...formData, resumePath: file.name });
      toast.info(`Resume selected: ${file.name}`);
    }
  };

  const handleSave = async () => {
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.phone ||
      !formData.jobPostingId
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const response = await post(
        "Onboarding/applicants",
        {
          organizationId: organizationId,
          centerId: savedCenterId,
          jobPostingId: parseInt(formData.jobPostingId),
          fullName: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          city: formData.city,
          expectedSalary: formData.expectedSalary
            ? parseFloat(formData.expectedSalary)
            : null,
          resumePath: formData.resumePath,
          coverLetter: formData.notes,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.success) {
        setShowSuccess(true);
        toast.success("Applicant saved successfully!");
        setTimeout(() => setShowSuccess(false), 3000);
        handleReset();
      }
    } catch (error) {
      console.error("Error saving applicant:", error);
      toast.error(error.response?.data?.message || "Failed to save applicant");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      jobPostingId: "",
      city: "",
      expectedSalary: "",
      resumePath: "",
      notes: "",
    });
    setShowSuccess(false);
  };

  return (
    <div className="row g-3">
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>New Applicant Form</h4>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="mb-3 fs-9 border-bottom pb-2">
              Applicant Information
            </h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">
                  Full Name<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Applicant name"
                  value={formData.fullName}
                  onChange={(e) => handleChange("fullName", e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Email<span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="name@email.com"
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Phone<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="03xx-xxxxxxx"
                  value={formData.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Applied For (Job Posting)
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={formData.jobPostingId}
                  onChange={(e) => handleChange("jobPostingId", e.target.value)}
                >
                  <option value="">-- Select Job Posting --</option>
                  {jobPostings.map((job) => (
                    <option key={job.id} value={job.id}>
                      {job.positionTitle} - {job.departmentName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">City</label>
                <input
                  className="form-control"
                  value={formData.city}
                  onChange={(e) => handleChange("city", e.target.value)}
                  placeholder="e.g., Karachi"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Expected Salary</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="e.g., 120000"
                  value={formData.expectedSalary}
                  onChange={(e) =>
                    handleChange("expectedSalary", e.target.value)
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label">Notes / Cover Letter</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Experience summary, references, etc."
                  value={formData.notes}
                  onChange={(e) => handleChange("notes", e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Resume (PDF/DOCX)</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                />
                {formData.resumePath && (
                  <small className="text-muted mt-1 d-block">
                    <i className="fas fa-file me-1"></i>
                    {formData.resumePath}
                  </small>
                )}
              </div>
            </div>

            <div className="mt-4 d-flex gap-2">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSave}
                disabled={loading}
              >
                <i className="fas fa-check me-1"></i>
                {loading ? "Saving..." : "Save Applicant"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleReset}
              >
                <i className="fas fa-redo me-1"></i>
                Reset
              </button>
            </div>

            {showSuccess && (
              <div className="alert alert-success mt-3">
                <i className="fas fa-check-circle me-2"></i>
                Applicant saved successfully! Check "All Applicant List" to
                view.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewApplicantForm;
